export default {
  container: {
    padding:10,
  },
};



// WEBPACK FOOTER //
// ./src/components/Common/SendSmsDialog/styles.js